import * as DTOS from "../FeralScan.dtos";
import { FilterState } from "../reducers/filter.reducer";


export interface IDataActions {
    type: string;
}

export interface IGetPlotSeasonSummaryDataRequestAction extends IDataActions {
    plotId: number
}

export interface IGetPlotSeasonSummaryDataSuccessAction extends IDataActions {
    plotId: number,
    plotSeasonSummaryData: DTOS.PlatypusPlotSeasonSummary[],
}

export interface IGetPlotSummaryDataRequestAction extends IDataActions {
    plotIds: number[];
    classifications: DTOS.Classification[];
    plotEventDateStart: any;
    plotEventDateEnd;
}

export interface IGetPlotSummaryDataSuccessAction extends IDataActions {
    plotSummaryData: DTOS.PlotSummary[];
}

export interface IGetUserPlotEventSummaryDataRequestAction extends IDataActions {
}

export interface IGetUserPlotEventSummaryDataSuccessAction extends IDataActions {
    userPlotEventSummaryData: DTOS.PlatypusUserPlotsEventsSummary;
}

export interface IGetPlotEventsRequestAction extends IDataActions {
    plotId?: number;
    userId?: number;
    limit?: number;
    createdDateStart?: any;
    createdDateEnd?: any;
}

export interface IGetPlotEventsSuccessAction extends IDataActions {
    plotEvents: DTOS.PlotEvent[];
    plotId: number;
}

export interface IGetSinglePlotRequestAction extends IDataActions {
    plotId: number;
}

export interface IGetSinglePlotSuccessAction extends IDataActions {
    plot: DTOS.Plot;
}


export interface IGetPlotsRequestAction extends IDataActions {
    createdDateStart: any;
    createdDateEnd: any;
    plotEventDateStart: any;
    plotEventDateEnd: any;
    plotStatusCodesToInclude: string[];
}

export interface IGetPlotsSuccessAction extends IDataActions {
    plots: DTOS.Plot[];
}

export interface IGetSummaryDataRequestAction extends IDataActions {
    classificationTypes: string[];
    plotId: number;
    questionCode: string;
}

export interface IGetSummaryDataSuccessAction extends IDataActions {
    data: DTOS.SummaryData[];
}

export interface IGetUserPlotsRequestAction extends IDataActions {
    includePlotEvents: boolean;
    specificUserId: number;
}

export interface IGetUserPlotsSuccessAction extends IDataActions {
    plots: DTOS.Plot[];
}

export interface IGetUserPlotsFailAction extends IDataActions {
}

export interface ISearchRequestAction extends IDataActions {
    filters: FilterState;
}

export interface ISearchSuccessAction extends IDataActions {
    layers: DTOS.KMLLayer[];
    plots: DTOS.Plot[];
    userPreference: DTOS.UserPreference;
}

export const
    GET_PLOT_EVENTS_REQUEST = "GET_PLOT_EVENTS_REQUEST",
    GET_PLOT_EVENTS_SUCCESS = "GET_PLOT_EVENTS_SUCCESS",

    GET_PLOT_SEASON_SUMMARY_DATA_REQUEST = "GET_PLOT_SEASON_SUMMARY_DATA_REQUEST",
    GET_PLOT_SEASON_SUMMARY_DATA_SUCCESS = "GET_PLOT_SEASON_SUMMARY_DATA_SUCCESS",

    GET_PLOT_SUMMARY_DATA_REQUEST = "GET_PLOT_SUMMARY_DATA_REQUEST",
    GET_PLOT_SUMMARY_DATA_SUCCESS = "GET_PLOT_SUMMARY_DATA_SUCCESS",

    GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_REQUEST = "GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_REQUEST",
    GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_SUCCESS = "GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_SUCCESS",
    
    GET_SINGLE_PLOT_REQUEST = "GET_SINGLE_PLOT_REQUEST",
    GET_SINGLE_PLOT_SUCCESS = "GET_SINGLE_PLOT_SUCCESS",

    GET_PLOTS_REQUEST = "GET_PLOTS_REQUEST",
    GET_PLOTS_SUCCESS = "GET_PLOTS_SUCCESS",

    GET_SUMMARY_DATA_REQUEST = "GET_SUMMARY_DATA_REQUEST",
    GET_SUMMARY_DATA_SUCCESS = "GET_SUMMARY_DATA_SUCCESS",

    GET_USER_PLOTS_REQUEST = "GET_USER_PLOTS_REQUEST",
    GET_USER_PLOTS_SUCCESS = "GET_USER_PLOTS_SUCCESS",
    GET_USER_PLOTS_FAIL = "GET_USER_PLOTS_FAIL",

    SEARCH_REQUEST = "SEARCH_REQUEST",
    SEARCH_SUCCESS = "SEARCH_SUCCESS";

export function getPlotSeasonSummaryDataRequest(plotId: number): IGetPlotSeasonSummaryDataRequestAction {
    return {
        type: GET_PLOT_SEASON_SUMMARY_DATA_REQUEST,
        plotId
    };
}

export function getPlotSeasonSummaryDataSuccess(response: DTOS.GetPlotSeasonSummaryDataResponse): IGetPlotSeasonSummaryDataSuccessAction {
    return {
        type: GET_PLOT_SEASON_SUMMARY_DATA_SUCCESS,
        plotSeasonSummaryData: response.plotSeasonSummaryData,
        plotId: response.plotId
    };
}

export function getPlotSummaryDataRequest(plotIds: number[], classifications: DTOS.Classification[], plotEventDateStart: any, plotEventDateEnd: any): IGetPlotSummaryDataRequestAction {
    return {
        type: GET_PLOT_SUMMARY_DATA_REQUEST,
        plotIds,
        classifications,
        plotEventDateStart,
        plotEventDateEnd
    };
}

export function getPlotSummaryDataSuccess(response: DTOS.GetPlotSummaryDataResponse): IGetPlotSummaryDataSuccessAction {
    return {
        type: GET_PLOT_SUMMARY_DATA_SUCCESS,
        plotSummaryData: response.plotSummaryData
    };
}

export function getUserPlotEventSummaryDataRequest(): IGetUserPlotEventSummaryDataRequestAction {
    return {
        type: GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_REQUEST
    };
}

export function getUserPlotEventSummaryDataSuccess(response: DTOS.GetPlatypusUserPlotsEventsSummaryResponse): IGetUserPlotEventSummaryDataSuccessAction {
    return {
        type: GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_SUCCESS,
        userPlotEventSummaryData: response.userPlotEventsSummaryData
    };
}

export function getPlotEventsRequest(plotId?: number, userId?: number, limit?: number, createdDateStart?, createdDateEnd?): IGetPlotEventsRequestAction {
    return {
        type: GET_PLOT_EVENTS_REQUEST,
        plotId,
        userId,
        limit,
        createdDateStart,
        createdDateEnd
    };
}

export function getPlotEventsSuccess(response: DTOS.GetPlotEventsResponse): IGetPlotEventsSuccessAction {
    return {
        type: GET_PLOT_EVENTS_SUCCESS,
        plotEvents: response.plotEvents,
        plotId: response.plotId
    };
}

export function getSinglePlotRequest(plotId: number): IGetSinglePlotRequestAction {
    return {
        type: GET_SINGLE_PLOT_REQUEST,
        plotId: plotId
    };
}

export function getSinglePlotSuccess(response: DTOS.GetSinglePlotResponse): IGetSinglePlotSuccessAction {
    return {
        type: GET_SINGLE_PLOT_SUCCESS,
        plot: response.plot
    };
}

export function getPlotsRequest(
    createdDateStart: any,
    createdDateEnd: any,
    plotEventDateStart: any,
    plotEventDateEnd: any,
    plotStatusCodesToInclude: string[]
): IGetPlotsRequestAction {
    return {
        type: GET_PLOTS_REQUEST,
        createdDateStart: createdDateStart,
        createdDateEnd: createdDateEnd,
        plotEventDateStart: plotEventDateStart,
        plotEventDateEnd: plotEventDateEnd,
        plotStatusCodesToInclude: plotStatusCodesToInclude,
    };
}

export function getPlotsSuccess(response: DTOS.GetPlotsResponse): IGetPlotsSuccessAction {
    return {
        type: GET_PLOTS_SUCCESS,
        plots: response.plots
    };
}

export function getUserPlotsRequest(includePlotEvents: boolean, specificUserId?: number): IGetUserPlotsRequestAction {
    return {
        type: GET_USER_PLOTS_REQUEST,
        includePlotEvents,
        specificUserId,
    }
}

export function getSummaryDataRequest(classificationTypes: string[], questionCode: string, plotId?: number): IGetSummaryDataRequestAction {
    return {
        type: GET_SUMMARY_DATA_REQUEST,
        classificationTypes,
        plotId,
        questionCode
    }
}

export function getSummaryDataSuccess(response: DTOS.GetSummaryDataByClassificationResponse): IGetSummaryDataSuccessAction {
    return {
        type: GET_SUMMARY_DATA_SUCCESS,
        data: response.data,
    }
}

export function getUserPlotsSuccess(response: DTOS.GetUserPlotsResponse): IGetUserPlotsSuccessAction {
    return {
        type: GET_USER_PLOTS_SUCCESS,
        plots: response.plots
    }
}

export function getUserPlotsFail(): IGetUserPlotsFailAction {
    return {
        type: GET_USER_PLOTS_FAIL
    }
}


export function searchRequest(filters: FilterState): ISearchRequestAction {
    return {
        type: SEARCH_REQUEST,
        filters: filters
    };
}

export function searchSuccess(response: DTOS.SearchResponse): ISearchSuccessAction {
    return {
        type: SEARCH_SUCCESS,
        plots: response.plots,
        layers: response.layers,
        userPreference: undefined//response.userPreference,
    };
}